function lockPageScroll() {
  document.querySelector('body').style.overflow = 'hidden'
}

function unlockPageScroll() {
  document.querySelector('body').style.overflow = 'auto'
}

function closeAllLightboxes() {
  const popups = document.querySelectorAll(`.gdc-js-grid-popup`)

  popups.forEach((p) => p.classList.add('gdc-hide-popup'))
  unlockPageScroll()
  window.removeEventListener('click', handleClosePopup)
}

function handleClosePopup(evt) {
  const clickedPopup = evt.target.closest('.gdc-gallery-grid-popup')
  const clickedSliderButton = evt.target.closest('.gdc-gallery-grid-popup__btn')

  if (!clickedPopup && !clickedSliderButton) {
    closeAllLightboxes()
  }
}

function handleGridPopup(evt) {
  const popupID = evt.currentTarget.dataset.block
  const popup = document.querySelector(`[data-popup="${popupID}"]`)

  popup.classList.remove('gdc-hide-popup')
  lockPageScroll()

  setTimeout(() => {
    window.addEventListener('click', handleClosePopup)
  }, 1000)
}

function handleSliderButton(e) {
  const direction = e.target.dataset.direction
  const gallery = e.target.closest('.gdc-gallery-grid__wrapper')
  const slides = gallery.querySelectorAll('.gdc-js-grid-popup')
  const currentSlide = [...slides].filter((slide) => !slide.classList.contains('gdc-hide-popup'))
  const currentSlideIndex = currentSlide[0].dataset.gridIndex - 1
  const nextSlide = currentSlideIndex + 1
  const prevSlide = currentSlideIndex - 1
  const firstSlide = 0
  const lastSlide = slides.length - 1

  const hideAllSlides = () => slides.forEach((slide) => slide.classList.add('gdc-hide-popup'))
  const handleDirection = () => (direction === 'forward' ? handleForward() : handleBack())
  const showSlide = (index) => slides[index].classList.remove('gdc-hide-popup')

  const handleForward = () => (slides[nextSlide] ? showSlide(nextSlide) : showSlide(firstSlide))

  const handleBack = () =>
    currentSlideIndex === firstSlide ? showSlide(lastSlide) : showSlide(prevSlide)

  hideAllSlides()
  handleDirection()
}

window.addEventListener('scroll', () => {
  closeAllLightboxes()
})

window.addEventListener('DOMContentLoaded', function () {
  window.removeEventListener('click', handleClosePopup)
})
